// @flow
import { getCookie, removeCookie } from "react-simple-cookie-store"
import { callAPI, LOGIN_ROUTE, SIGNUP_ROUTE, FORGOT_EMAIL_ROUTE } from "../API"
import { ACCESS_TOKEN, REFRESH_TOKEN } from "./constants"
import type { UserRegistration } from "./types"
import { saveTokens } from "./tokenHelpers"

/**
 * Registers a new account against the API.
 * @param {UserRegistration} user The values used to register the user.
 * @returns JSON response from the API request.
 */
export async function createUser(user: UserRegistration): any {
  const response = await callAPI(SIGNUP_ROUTE, user)
  return await response.json()
}

/**
 * Requests a fresh set of access tokens against the API.
 * @param {string} email The email address of the user's account.
 * @param {string} password The password to authenticate with.
 * @returns JSON response from the API request.
 */
export async function loginUser(email: string, password: string): any {
  const body = await callAPI(LOGIN_ROUTE, {
    email,
    password,
    grantType: "password"
  })
  const json = await body.json()
  json && json.data && saveTokens(json.data.token, json.data.refresh)
  return json
}

/**
 * Requests a magic link email to automatically sign in the user.
 * @param {string} email The email address of the user's account.
 * @returns JSON response from the API request.
 */
export async function sendMagicLink(email: string): any {
  const body = await callAPI(FORGOT_EMAIL_ROUTE, { email })
  const json = await body.json()
  return json
}

/**
 * Clears cookies related to the current user's session.
 */
export function logoutUser() {
  removeCookie(ACCESS_TOKEN)
  removeCookie(REFRESH_TOKEN)
}

/**
 * Returns true if a session token for the current user is present.
 * @returns True if a session is present.
 */
export function isLoggedIn(): boolean {
  return typeof getCookie(ACCESS_TOKEN) === "string"
}



// WEBPACK FOOTER //
// ./src/Auth/userHelpers.js